export function getIsInvoiceOld(invoiceIssueDate: string | null | undefined): boolean | null {
    if (!invoiceIssueDate) return false

    const invoiceDate = new Date(invoiceIssueDate)
    const oneYearAgo = new Date()

    oneYearAgo.setFullYear(oneYearAgo.getFullYear() - 1)

    return invoiceDate < oneYearAgo
}
